import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

const LengthToggleContainer = styled.div`
  display: flex;
  column-gap: ${(props) => props.theme.size.dynamic0020};
  align-items: baseline;
  margin: ${(props) => props.theme.size.dynamic0040} 0
    ${(props) => props.theme.size.dynamic0100};
`;

const SkeletonButton = styled.div`
  width: 80px;
  height: 32px;
  background: linear-gradient(
    90deg,
    ${({theme}) => theme.colors.background.tertiary} 25%,
    ${({theme}) => theme.colors.background.secondary} 50%,
    ${({theme}) => theme.colors.background.tertiary} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: ${({theme}) => theme.size.borderRadius.xSmall};

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  &:first-child::after {
    content: '';
    display: inline-block;
    width: 1px;
    height: 18px;
    background-color: ${({theme}) => theme.colors.border.divider};
    vertical-align: middle;
    margin-left: 6px;
    margin-right: 2px;
  }
`;

export const LengthToggleSkeleton = () => {
  return (
    <LengthToggleContainer>
      <SkeletonButton />
      <SkeletonButton />
    </LengthToggleContainer>
  );
};
